import { useForm } from "react-hook-form";
import { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";




interface AskExpertModalProps {
  isOpen: boolean;
  onClose: () => void;
  course?:string;
}

const AskExpertModal = ({ isOpen, onClose, course }: AskExpertModalProps) => {
  const { register, handleSubmit, watch, reset, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const selectedQuestion = watch("question");

  const sendEmailWithBrevo = async (firstName: string, lastName: string, email: string, question: string) => {
    const emailData =  {
      sender: {
        name: "Ask An Expert" ,
        email: "info@doyenify.com" },
      to: [{ email:  "info.doyenify@gmail.com" }],
      replyTo:{
        email:"info.doyenify@gmail.com",
      },
      subject: "New Ask Expert Submission",
      htmlContent: `<p><strong>First Name:</strong> {{params.firstName}}</p>
                    <p><strong>Last Name:</strong> {{params.lastName}}</p>
                    <p><strong>Course Asked About:</strong> {{params.course}}</p>
                    <p><strong>Email:</strong> {{params.email}}</p>
                    <p><strong>Question:</strong> {{params.question}}</p>`,

     params: {
      firstName,
      lastName,
      email,
      question,
      course: course || "No course specified"
     }
    };

    try {
    const response = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
          process.env.REACT_APP_SERVICE_KEY, {
          method: "post",
          body: JSON.stringify({
            email: process.env.REACT_APP_SERVICE_EMAIL,
            password: process.env.REACT_APP_SERVICE_PASSWORD,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const userToken = await response.json();
        await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), emailData, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then()
        .catch(() => {
          console.log("(axios) an error occurred")
        });

    } catch (err) {
      throw new Error("Failed to send email");
    }
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    setError("");
    const questionToSend = data.question === "Others" ? data.customQuestion : data.question;

    try {
      await sendEmailWithBrevo(data.firstName, data.lastName, data.email, questionToSend);
      toast.success("Your question has been sent");
      reset();
      setTimeout(()=>{
        onClose(); 
      }, 2000);
    } catch (err) {
      setError("Failed to send your question. Please try again.");
    } finally {
      setLoading(false);
    }
  };

const handleClose =()=>{
  onClose();
  setError('')
  reset();
};


  if (!isOpen) return null; 

  return (
    <div className="fixed z-[999] inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <ToastContainer autoClose={1000} />
      <div className="bg-white rounded-[20px] shadow-lg max-w-[700px] sm:w-full md:w-[600px] max-h-[90vh] overflow-auto relative">
        <div className='bg-[#047711] py-3'>
        <h2 className="text-center text-lg font-bold text-[#ffffff]">Kindly Ask Expert</h2>
        <button onClick={handleClose} className="absolute top-3 right-3 text-[#ffffff] text-lg">✖</button>
        </div>
        
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 mt-4 mb-4 px-10  py-6">
         
          <div className="grid grid-cols-2 gap-2">
            <div>
            <label className='text-[18px]'>First name</label>
              <input
                type="text"
                {...register("firstName", { required: "First Name is required" })}
                className="w-full p-2 border border-[#0F7D1A] bg-[#F2FFD8] rounded"
                placeholder="First Name"
              />
              {typeof errors.firstName?.message === "string" && <p className="text-red-500 text-xs">{errors.firstName.message}</p>}
            </div>
            <div>
                <label className='text-[18px]'>Last name</label>
              <input
                type="text"
                {...register("lastName", { required: "Last Name is required" })}
                className="w-full p-2 border border-[#0F7D1A] bg-[#F2FFD8] rounded"
                placeholder="Last Name"
              />
              {typeof errors.lastName?.message === "string" && <p className="text-red-500 text-xs">{errors.lastName.message}</p>}
            </div>
          </div>
         <div>
         <label className='text-[18px]'>Email</label>
          <input
            type="email"
            {...register("email", { required: "Email is required", pattern: /^\S+@\S+\.\S+$/ })}
            className="w-full p-2  border border-[#0F7D1A] bg-[#F2FFD8] rounded"
            placeholder="Email"
          />
          {typeof errors.email?.message === "string" && <p className="text-red-500 text-xs">{errors.email.message}</p>}
          </div>

           <div>    
          <label className='text-[18px]'>Ask Expert</label>
          <select {...register("question", { required: "Please select a question" })} className="w-full p-2 border font-[700] border-[#0F7D1A] text-[15px] bg-[#F2FFD8] rounded">
            <option value="bb">Select a question</option>
            <option value="Are there any prerequisites for enrolling in this course?">Are there any prerequisites for enrolling in this course?</option>
            <option value="Is the course self-paced, or are there scheduled live sessions?">Is the course self-paced, or are there scheduled live sessions?</option>
            <option value="Will I receive any mentorship or one-on-one guidance during the course?">Will I receive any mentorship or one-on-one guidance during the course?</option>
            <option value="Do you provide hands-on projects or real-world applications in this course?">Do you provide hands-on projects or real-world applications in this course?</option>
            <option value="How is student progress tracked and assessed throughout the course?">How is student progress tracked and assessed throughout the course?</option>
            <option value="How do I enroll, and what is the deadline for registration and when is the class starting?">How do I enroll, and what is the deadline for registration and when is the class starting?</option>
            <option value="Others">Others</option>
          </select>
          {typeof errors.question?.message === "string" && <p className="text-red-500 text-xs">{errors.question.message}</p>}
          </div>

          {selectedQuestion === "Others" && (
            <div>
              <textarea
                {...register("customQuestion", { required: "Please enter your question" })}
                className="w-full p-2 border border-[#0F7D1A] bg-[#F2FFD8] rounded"
                placeholder="Type your question here..."
              ></textarea>
              {typeof errors.customQuestion?.message === "string" && <p className="text-red-500 text-xs">{errors.customQuestion.message}</p>}
            </div>
          )}

          {error && <p className="text-red-500 text-xs">{error}</p>}
          
          <button type="submit" className="w-full p-2 bg-[#0F4B16] text-white rounded " disabled={loading}>
            {loading ? "Sending..." : "Ask Expert"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AskExpertModal;
